import { Routes } from '@angular/router';
import { CourseComponent } from './course/course.component';
import { HomeComponent } from './home/home.component';
var ɵ0 = {
    title: '',
};
// tslint:disable: max-line-length
var routes = [
    {
        path: '',
        pathMatch: 'full',
        component: HomeComponent,
        data: ɵ0,
    },
    {
        path: 's/:courseSlug',
        component: CourseComponent
    },
];
// @ts-ignore
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0 };
